import { render } from "./FormDatPerso.vue?vue&type=template&id=09f2fdaa&scoped=true"
import script from "./FormDatPerso.vue?vue&type=script&lang=js"
export * from "./FormDatPerso.vue?vue&type=script&lang=js"

import "./FormDatPerso.vue?vue&type=style&index=0&id=09f2fdaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-09f2fdaa"

export default script